// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2oVL2","content":"styles_content__3Exl7","checkbox":"styles_checkbox__2Pbwz","checkboxLabel":"styles_checkboxLabel__1gz7a"};